module.exports = __webpack_public_path__ + "img/selfie.61fa7dee.png";